<template>
  <base-modal
    :is-visible="isVisible"
    @hideModal="hideModal()"
    :is-editable="false"
    :is-archivable="false"
    size="lg"
  >
    <template #header></template>
    <template #body>
      <Loader v-if="isLoading"></Loader>
      <div v-else>
        <b-container class="no-shadow bordered no-height100 col-sm-12 col-lg-12" v-for="(item, index) in agreementsConsents" v-bind:key="index" :id="'AgreementsConsents-' + index">
          <div class="row mgcorrect pdcorrect">
            <div v-if="item" class="col-sm-12 col-lg-12">
              <p class="m-0" ><b>{{item.consent.title}}</b></p>
              <small>{{item.consent.description}}</small>
              <div class="form-group mt-4" v-if="item.requireConsent !== 1">
                <label>{{$t("views.agreements.form.agree")}}:
                  <b-form-group>
                    <b-form-radio-group buttons button-variant="outline-primary" v-model="item.agree" size="sm">
                      <b-form-radio button-variant="outline-success" @change="itemAccept(index)" :value="2">{{$t("views.agreements.form.agree")}}</b-form-radio>
                      <b-form-radio button-variant="outline-danger" @change="itemDiscard(index)" :value="1">{{$t("views.agreements.form.noagree")}}</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </label>
              </div>
              <div class="form-group mt-4" v-if="item.requireConsent === 1">
                <p><b>{{$t("views.agreements.form.agreeRequired")}}</b></p>
              </div>
            </div>
          </div>
          <hr class="mt-1 mb-1">
        </b-container>
        <button v-if="!getSignBySMS" type="button" class="btn btn-success" @click="accept()" > {{ $t('buttons.acceptOffer') }} </button>
        <button v-else-if="getSignBySMS && !wasSMSSend" type="button" class="btn btn-success" @click="accept()" > {{ $t('buttons.sendSMS') }} </button>
        <div v-if="getSignBySMS && wasSMSSend">
          <label>{{$t("views.agreements.form.SMSMessage") + ' ' + SMSCount}}:</label>
          <input v-model="confirmationPin" name="SMSCode" type="text" class="form-control"/>
          <button type="button" class="btn btn-success" @click="sign()" > {{ $t('buttons.sign') }} </button>
        </div>
      </div>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import Loader from '@/components/Dashboard/Layout/Loader'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'AgreementAcceptModal',
  components: {
    BaseModal,
    Loader
  },
  data () {
    return {
      error: false
    }
  },
  computed: {
    confirmationPin: {
      get () {
        return this.getSMSCode
      },
      set (val) {
        this.setSMSCode(val)
      }
    },
    ...mapGetters({
      isVisible: 'agreements/acceptModal/getIsAgreementAcceptModalVisible',
      isLoading: 'agreements/acceptModal/getIsLoadingAgreement',
      agreementsConsents: 'agreements/acceptModal/getAgreementConsents',
      accepted: 'agreements/acceptModal/getAccepted',
      getSignBySMS: 'agreements/acceptModal/getSignBySMS',
      wasSMSSend: 'agreements/acceptModal/getWasSMSSend',
      getSMSCode: 'agreements/acceptModal/getSMSCode',
      SMSCount: 'agreements/acceptModal/getSMSCount'
    })
  },
  watch: {
    accepted (val) {
      if (val) {
        this.reset()
        this.resetPreviewModal()
      }
    }
  },
  methods: {
    accept () {
      // validate consents
      this.agreementsConsents.forEach(consent => {
        if (consent.agree === 0) {
          this.error = true
          throw this.$Swal({
            type: 'warning',
            text: this.$t('views.agreements.form.accept.consentRequired'),
            timer: 2500
          })
        } else if (consent.agree === 1 && consent.consent.requireConsent === 1) {
          this.error = true
          throw this.$Swal({
            type: 'warning',
            text: this.$t('views.agreements.form.consent') + ' ' +
              consent.consent.title + ' ' + this.$t('views.agreements.form.accept.isRequired'),
            timer: 2500
          })
        }
      })
      if (!this.error && !this.getSignBySMS) {
        this.acceptOffer()
      } else if (!this.error && this.getSignBySMS) {
        this.requestSMS()
      }
      this.error = false
    },
    itemAccept (index) {
      this.acceptSingleConsent(index)
    },
    itemDiscard (index) {
      this.discardSingleConsent(index)
    },
    hideModal () {
      this.toggleAgreementAcceptModal()
      this.reset()
    },
    ...mapMutations({
      toggleAgreementAcceptModal: 'agreements/acceptModal/toggleAgreementAcceptModal',
      acceptSingleConsent: 'agreements/acceptModal/acceptSingleConsent',
      discardSingleConsent: 'agreements/acceptModal/discardSingleConsent',
      setSMSCode: 'agreements/acceptModal/setSMSCode',
      reset: 'agreements/acceptModal/reset',
      toggleAgreementPreviewHTMLModal: 'agreements/previewModal/toggleAgreementPreviewHTMLModal',
      resetPreviewModal: 'agreements/previewModal/reset'
    }),
    ...mapActions({
      acceptOffer: 'agreements/acceptModal/acceptOffer',
      sign: 'agreements/acceptModal/sign',
      requestSMS: 'agreements/acceptModal/requestSignBySMS'
    })
  }
}
</script>

<style scoped>

</style>
